<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';
  //reset
  button{
    background-color: transparent;
    margin: 0;
    padding: 0;
    appearance: none;
    box-shadow: none;
    border-radius: none;
    border: none;
    zoom: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-user-drag: none;
    user-select: none;
    &:focus {
        outline: none;
    }
  }

  .button {
    display: inline-block;
    color: color("flamingo", "dark");
    background-color: color("flamingo");
    padding: 0.75em 0.9em;
    border-radius: 0.4rem;
    text-decoration: none;
    transition: all 0.5s cubic-bezier(.2,.86,.28,.92);
    line-height: 1em;
    font-size: font-size("deka");
    &:hover, &:focus {
      color: color("white");
      background-color: color("flamingo", "dark");
    }
    &:active {
      background-color: color("flamingo");
      box-shadow: none;
    }
    &__label{
      line-height: 1em;
    }
    &.\--dark {
      background-color: color("black");
      color: color("white");
    }
    &.\--secondary {
      background-color: color("grey", "darker");
      color: color("black");
      &:hover, &:focus {
        color: color("white");
        background-color: color("grey", "darkest");
      }
    }
    &.\--small{

    }
    &.\--blank{
      background-color: transparent;
      box-shadow: none;
      color: color("black");
      &:hover{
        color: color("black");
      }
    }
  }
  .button-link{

  }

  .button-circle{
    border-radius: 999px;
    padding: 0.5em;
    fill: color('white');
    &:hover, &:focus {
      background-color: color('flamingo', 'dark');
    }
    &:active {
      background-color: color('flamingo');
      box-shadow: none;
    }
  }

  .button-circle, .button{
    &.\--warning{
      &:hover {
        background-color: color("warning") !important;
        color: color("white") !important;
        &.\--levitate{
          box-shadow: 0px 4px 16px 0px rgba(130, 75, 74, 1);
        }
      }
    }
    &.\--nile{
      background-color: color('nile');
      color: color('white');
      &:hover {
        background-color: color('nile', 'dark');
        &.\--levitate{
          box-shadow: 0px 4px 16px 0px rgba(130, 75, 74, 1);
        }
      }
      &.\--levitate{
        box-shadow: 0px 4px 16px 0px rgba(27, 27, 34, 0.82);
      }
    }
    &.\--white{
      background-color: color('white');
      color: color('black');
      &:hover {
        background-color: color('grey', 'darker');
        &.\--levitate{
          box-shadow: 0px 4px 16px 0px rgba(130, 75, 74, 1);
        }
      }

      &.\--levitate{
        box-shadow: 0px 4px 16px 0px rgba(27, 27, 34, 0.82);
      }
    }
    &.\--grey{
      background-color: color('grey');
      color: color('black');
      &:hover {
        background-color: color('grey', 'darker');
        &.\--levitate{
          box-shadow: 0px 4px 16px 0px rgba(130, 75, 74, 1);
        }
      }

      &.\--levitate{
        box-shadow: 0px 4px 16px 0px rgba(27, 27, 34, 0.82);
      }
    }
  }

</style>
<template>
  <button @click="callback($event)" :class="cssClass">
     <slot>Button</slot>
  </button>
</template>
<script>
// import myFile from'./pathToMyFile';

export default {
  data() {
    return {

    };
  },
  props: {
    cssClass: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'submit'
    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    callback (e) {
      this.$emit('click', e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/button.vue